module.exports = __webpack_public_path__ + "img/ic-defauts-visuels.a4270010.svg";